import { http } from 'services/http';
import type { CreateInvoiceReq, InvoiceRes } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';
import { INVOICES_GET_MANY } from '../query-keys.ts';

export const useCreateInvoice = () => {
  return useMutationBase<InvoiceRes, unknown, CreateInvoiceReq>({
    mutationFn: async (variables) => {
      const res = await http.post<InvoiceRes>('/v1/invoices', variables);

      return res.data;
    },

    invalidateCallback: () => [[INVOICES_GET_MANY]],
  });
};
